var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.load),expression:"load"}],attrs:{"fullscrean":true,"text":"Carregando as informações"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }